/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, View } from 'react-native';
import { spacing } from '../../../shared/theme/spacing';
import { useBusinessProfileStore } from '../../../shell/session/store/useBusinessProfileStore';
import { useHasBusinessCapability } from '../../../shell/session/hooks/useEffectiveBusinessCapabilities';
import {
  isRetailCounterBusinessType,
} from '../../../auth/screens/onboarding/retailOnboardingCopy';
import { styles } from '../ReportsScreen.styles';
import { ReportsDenseListCard } from './ReportsDenseListCard';
import { formatMoney } from '../../../shared/format/public-api';

type Props = {
  externalServiceSummary: {
    total: number;
    count: number;
  } | null;
};

export function RetailCounterReportsBand({
  externalServiceSummary,
}: Props) {
  const businessType = useBusinessProfileStore((s) => s.profile?.business_type_code);
  const allowsExternalServices = useHasBusinessCapability('external_services');

  const visible = isRetailCounterBusinessType(businessType);

  if (!visible || !allowsExternalServices) return null;

  const hasOps = (externalServiceSummary?.count ?? 0) > 0;

  return (
    <ReportsDenseListCard>
      <Text style={styles.reportsDenseBlockTitle}>Recargas y servicios</Text>
      <Text style={styles.caption}>
        SUBE y carga virtual. Las registrás en el POS. No son ventas del catálogo.
      </Text>

      <View style={{ gap: spacing.xs, marginTop: spacing.sm }}>
        {hasOps ? (
          <View style={styles.reportsDenseListFieldRow}>
            <Text style={styles.reportsDenseListFieldLabel}>Total del período</Text>
            <Text style={styles.reportsDenseListFieldValue}>
              {formatMoney(externalServiceSummary!.total)} ({externalServiceSummary!.count})
            </Text>
          </View>
        ) : (
          <Text style={styles.caption}>Sin recargas registradas en este período.</Text>
        )}
      </View>
    </ReportsDenseListCard>
  );
}
